import React from "react";
import { connect } from "react-redux";

import BoundaryType from "@mapmycustomers/shared/enum/BoundaryType";

import {
  areBoundariesVisible,
  getBoundaryType,
} from "@app/scene/map/store/layers/boundaries/selectors";
import { RootState } from "@app/store/rootReducer";

import DemographyLayer from "../Demography";
import TerritoriesLayer from "../Territories";

interface Props {
  type: BoundaryType;
  visible: boolean;
}

const BoundariesLayer: React.FC<Props> = ({ type, visible }) => {
  return visible ? (
    type === BoundaryType.TERRITORY ? (
      <TerritoriesLayer />
    ) : (
      <DemographyLayer />
    )
  ) : null;
};

const mapStateToProps = (state: RootState) => ({
  type: getBoundaryType(state),
  visible: areBoundariesVisible(state),
});

export default connect(mapStateToProps)(BoundariesLayer);
